import { PRECISION, SCALE } from "../precision";

export const formatDecimal = (value) => {
  if (value == null || isNaN(value)) return "---";
  return (value / SCALE)?.toFixed(PRECISION);
};
